function SudokuHome() {
    return (
        <section className='content-wrapper'>
            <h1>스도쿠</h1>
            <hr></hr>
            <article>
                <p>
                    <em>스도쿠</em>는 가로 9칸, 세로 9칸의 격자판 위에서 진행하는 배치 퍼즐의 일종입니다.
                </p>
            </article>
            <hr></hr>
        </section>
    );
}

export default SudokuHome;